module.exports = __webpack_public_path__ + "static/img/iconfont.7b8bbc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.svg?t=1733723353149
// module id = UJUM
// module chunks = 3